<div class="nav-top">
    <div class="item" [ngClass]="{'item-active':activeRoute=='reporting-list'}" (click)="goto('reporting-list')">Reporting list</div>
    <div class="item" [ngClass]="{'item-active':activeRoute=='reporting-details'}" (click)="goto('reporting-details')">Advertisement</div>
</div>
<router-outlet></router-outlet>